import { downloadBlob } from '@mint-lib/api-zod-support';
import { atom, useAtom } from 'jotai';

export type ReportPreviewData = {
  blobUrl: string;
  fileName: string;
  blob?: Blob;
};

export const isOpenReportPreviewAtom = atom<boolean>(false);
export const isReportPreviewFullscreenAtom = atom<boolean>(false);
const fileReportPreviewAtom = atom<ReportPreviewData>({
  blobUrl: '',
  fileName: '',
  blob: undefined,
});

const useReportPreviewModal = () => {
  const [open, setIsOpen] = useAtom(isOpenReportPreviewAtom);
  const [isFullScreen, setIsFullScreen] = useAtom(
    isReportPreviewFullscreenAtom,
  );

  const onClose = () => {
    setIsOpen(false);
    setIsFullScreen(false);
  };

  const onOpen = () => {
    setIsOpen(true);
  };

  const toggleFullScreen = () => {
    setIsFullScreen((prev) => !prev);
  };

  return {
    open,
    onClose,
    onOpen,
    isFullScreen,
    toggleFullScreen,
  };
};

const useReportPreviewData = () => {
  const [reportData, setReport] = useAtom(fileReportPreviewAtom);

  const downloadReport = () => {
    if (!reportData.blob) return;
    downloadBlob(reportData.blob, reportData.fileName);
  };

  return {
    reportData,
    setReport,
    downloadReport,
  };
};

export { useReportPreviewData, useReportPreviewModal };
